import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/static/illustrations/onboarding/astronaut.png'


const _withScopeId = n => (_pushScopeId("data-v-1747e939"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layout__banner" }, "Hora de decolar!", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageBox = _resolveComponent("MessageBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MessageBox, {
      class: "layout__message",
      message: $props.message,
      top: "9rem",
      left: "calc(30% + 1rem)"
    }, null, 8, ["message"]),
    _hoisted_2,
    _createElementVNode("img", {
      class: _normalizeClass([
        'layout__astronaut',
        { 'fluctuate-facing-right': $setup.isTransitionFinished },
        { reverse: $props.animationIsReverse },
      ]),
      src: _imports_0,
      alt: "Astronauta",
      onAnimationend: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.fluctuate && $setup.fluctuate(...args)))
    }, null, 34)
  ]))
}